// extracted by mini-css-extract-plugin
module.exports = {"dSegment":"DeleteModal_dSegment__B7we0"};